import { z } from "zod";

/** DPO Forecast — read-only, 18-month rolling, PO vs PR toggle (POIndicator). */
export const dpoFilterSchema = z.object({
  vendorId: z.coerce.number().int().optional(),
  materialNumber: z.string().optional(),
  plantId: z.coerce.number().int().optional(),
  status: z.enum(["All", "Open", "Past Due"]).optional().default("All"),
  poIndicator: z.enum(["PO", "PR"]).optional().default("PO"),
  limit: z.coerce.number().int().min(1).max(500).default(200),
});
export type DpoFilterInput = z.infer<typeof dpoFilterSchema>;
